import { HttpParams } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { LazyLoadEvent } from 'primeng/primeng';
import { Observable } from 'rxjs/Observable';
import { tap } from 'rxjs/operators';

import { BaseCrudService } from '../../shared/_utils/services/base-crud-service';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';
import { ResponsePageable } from '../../shared/_utils/services/responsePageable';
import { CostCenter } from '../entities/costCenter';
import { EmployeeManager } from '../entities/employee-manager';

interface ExtraSearchFields {
    employeeManager?: EmployeeManager
}

@Injectable()
export class CostCenterService extends BaseCrudService<CostCenter> {

    public uri = '/api/costCenter/';

    constructor(injector: Injector) {
        super(injector);
       //console.log('Instance CostCenterService');
    }

    buildSentence(entity?: CostCenter, event?: LazyLoadEvent, extraSearchFields?: ExtraSearchFields): HttpParams {
        this.httpParams = new HttpParams();
        if (entity || extraSearchFields) {
            let query = ''
            query = query.concat(
                entity && entity.code ?
                `code${QueryOperator.Contain}${entity.code}${QueryOperator.Split}`
                : QueryOperator.Empty
            );
            query = query.concat(
                entity && entity.name ?
                `name${QueryOperator.Contain}${entity.name}${QueryOperator.Split}`
                : QueryOperator.Empty
            );
            if (entity && entity.fiscalYear) {
                query = query.concat(
                    entity.fiscalYear.id ? 'fiscalYear.id' + QueryOperator.Equal
                        + entity.fiscalYear.id + QueryOperator.Split : QueryOperator.Empty
                );
            }
            if (entity && entity.executingUnit) {
                query = query.concat(
                    entity.executingUnit.id ? 'executingUnit.id'
                        + QueryOperator.Equal + entity.executingUnit.id
                        + QueryOperator.Split : QueryOperator.Empty
                );
            }
            if (entity && entity.costCenterDivision) {
                query = query.concat(entity.costCenterDivision.id ? 'costCenterDivision.id'
                    + QueryOperator.Equal + entity.costCenterDivision.id
                    + QueryOperator.Split : QueryOperator.Empty
                );
            }
            if (entity && entity.district) {
                query = query.concat(
                    entity.district.id ? 'district.id'
                        + QueryOperator.Equal + entity.district.id
                        + QueryOperator.Split : QueryOperator.Empty
                );
            }

            if (extraSearchFields) {
                query = query.concat(
                    extraSearchFields.employeeManager && extraSearchFields.employeeManager.employee ?
                    `employee.id${QueryOperator.Equal}${extraSearchFields.employeeManager.employee.id}${QueryOperator.Split}`
                    : QueryOperator.Empty
                );
            }

            this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
        }

        if (event) {
            const page = ((event.first + event.rows) / event.rows - 1).toString();
            const size = event.rows.toString();
            this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
            this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
        }
        return this.httpParams;
    }

    searchByEmployeeOfEmployeeManager(event?: LazyLoadEvent,
                                extraSearchFields?: ExtraSearchFields): Observable<ResponsePageable<CostCenter>> {

        const url = `${this.rutaServidor}${this.uri}search`;
        let httpParams = this.buildSentence(undefined, undefined, extraSearchFields);
        httpParams = this.httpParams.set(QueryOperator.SearchName, 'searchByEmployeeOfEmployeeManager');
        this.spinnerService.showAll();
        return this.httpClient.get<ResponsePageable<CostCenter>>(url, { params: httpParams })
            .pipe(
                tap(response => {
                   //console.log('searchByEmployeeManager');
                    if (response.numberOfElements > 0) {
                       //console.log(response.content);
                        response.content.forEach((value) => {
                            // debugger;
                            this.addLogicToSearch(value);
                            this.convertToDate(value);
                        })
                    }
                   //console.log(response.content);
                    this.spinnerService.hideAll();
                    return response;
                })
            );
    }
}



// WEBPACK FOOTER //
// ./src/app/core/services/cost-center.service.ts